module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand3-3e146da1f5e298657939a3d8ea702894.jpg";